import { DATE_DD_MON_YEAR } from 'constants/dateFormat';
import { IColumnProps } from 'devextreme-react/data-grid';
import { CustomizeText } from 'shared/types';

export const getFields = ({
  customizeText,
}: {
  customizeText: CustomizeText;
}): IColumnProps[] => [
  {
    dataField: 'date',
    caption: 'Date',
    alignment: 'left',
    type: 'datetime',
    dataType: 'date',
    format: DATE_DD_MON_YEAR,
    sortOrder: 'desc',
    allowSorting: 'true',
  },
  {
    dataField: 'plNav',
    caption: 'P&L',
    alignment: 'right',
    format: '#,##0',
  },
  {
    dataField: 'varHis',
    caption: 'VaR (His, 1M, 99% Confidence) (USD)',
    alignment: 'right',
    format: '#,##0',
  },
  {
    dataField: 'lossOvershooting',
    caption: '99% Loss Overshooting Ratio',
    alignment: 'right',
    customizeText,
  },
];
